/* Hàng đợi ghi nền — docs/03-KIEN-TRUC.md mục 5.
   Mỗi thao tác: { id (client_op_id), rpc, args, key, label, tries, at }.
   Gửi tuần tự, thất bại vì mạng thì thử lại 1s → 2s → 5s → 10s…; lỗi nghiệp vụ
   (server trả ok:false) thì bỏ khỏi hàng đợi và báo qua onError.
   Sao lưu IndexedDB để đóng tab giữa chừng không mất thao tác. */
import { rpc } from './supabase.js';
import { kvGet, kvSet, log } from './ui.js';

const Q = { items: [], sending: false, timer: null, onChange: null, onError: null, onAck: null, lastAck: null };
const KV = 'outbox';

export function uuid() {
  if (crypto.randomUUID) return crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => { const r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
}

export async function queueInit(handlers) {
  Object.assign(Q, handlers || {});
  try {
    const saved = await kvGet(KV);
    if (Array.isArray(saved) && saved.length) {
      Q.items = saved;
      log('Có ' + saved.length + ' thao tác chưa gửi từ lần trước — gửi tiếp.', 'wr');
    }
  } catch (e) { }
  window.addEventListener('online', () => kick(0));
  notify(); kick(0);
}

export function enqueue(op) {
  op.id = op.id || uuid(); op.tries = 0; op.at = new Date().toISOString();
  Q.items.push(op); persist(); notify(); kick(0);
  return op.id;
}
export function pending() { return Q.items.length; }
export function pendingKeys() { const s = new Set(); Q.items.forEach((o) => { if (o.key) s.add(o.key); (o.keys || []).forEach((k) => s.add(k)); }); return s; }
export function lastAck() { return Q.lastAck; }

function persist() { kvSet(KV, Q.items).catch(() => { }); }
function notify() { if (Q.onChange) Q.onChange(Q.items.length, Q.sending); }
function kick(ms) { clearTimeout(Q.timer); Q.timer = setTimeout(send, ms); }

async function send() {
  if (Q.sending || !Q.items.length) return;
  if (!navigator.onLine) { notify(); return; }
  Q.sending = true; notify();
  const op = Q.items[0];
  try {
    const { data, ms } = await rpc(op.rpc, Object.assign({}, op.args, { p_op: op.id }));
    Q.items.shift(); persist();
    Q.lastAck = new Date();
    if (data && data.ok === false) {
      log('Máy chủ từ chối ' + (op.label || op.rpc) + ': ' + (data.code || '?'), 'er');
      if (Q.onError) Q.onError(op, data);
    } else {
      if (Q.onAck) Q.onAck(op, data, ms);
    }
    Q.sending = false; notify();
    if (Q.items.length) kick(0);
  } catch (e) {
    Q.sending = false;
    op.tries++;
    const net = /Mất kết nối|Failed to fetch|NetworkError|timeout/i.test(e.message);
    if (net || op.tries < 5) {
      const wait = [1000, 2000, 5000, 10000, 20000][Math.min(op.tries - 1, 4)];
      log('Chưa gửi được ' + (op.label || op.rpc) + ' (' + e.message + ') — thử lại sau ' + (wait / 1000) + 's', 'wr');
      persist(); notify(); kick(wait);
    } else {
      Q.items.shift(); persist();
      log('BỎ thao tác ' + (op.label || op.rpc) + ' sau ' + op.tries + ' lần: ' + e.message, 'er');
      if (Q.onError) Q.onError(op, { code: 'RPC_ERROR', message: e.message });
      notify(); if (Q.items.length) kick(0);
    }
  }
}
